export const data = [
  {
    id: 1,
    title: 'Mynet Analytics Verileri',
    titleEN: 'Mynet Analytics Data',
    image: 'https://srv-cdn.onedio.com/store/6ed084ca69f79197482ab2e035b2beeeed2801bf355d32c795fac6e006388256.png',
    imageEN: 'https://srv-cdn.onedio.com/store/da0f20ac313acfa7c3c313b0f6de1825671c088a99ce8774c840ea7d70a32c05.png',
    active: true
  },
  {
    id: 2,
    title: 'Cinsiyet',
    titleEN: 'Gender',
    image: 'https://srv-cdn.onedio.com/store/59a02abe313fe0c547531d87ba12e1ab5520160f592e526875cd5deb63e3de8f.png',
    imageEN: 'https://srv-cdn.onedio.com/store/59a02abe313fe0c547531d87ba12e1ab5520160f592e526875cd5deb63e3de8f.png',
    active: false
  },
  {
    id: 3,
    title: 'Yaş Kırılımı',
    titleEN: 'Age Distribution',
    image: 'https://srv-cdn.onedio.com/store/c4675358cf3d6d7a678d24677d9bc008c7b27b2b52a57dac83f71dae1d38e139.png',
    imageEN: 'https://srv-cdn.onedio.com/store/c4675358cf3d6d7a678d24677d9bc008c7b27b2b52a57dac83f71dae1d38e139.png',
    active: false
  },
  {
    id: 4,
    title: 'Sosyal Medya',
    titleEN: 'Social Media',
    image: 'https://srv-cdn.onedio.com/store/a8121da2c8598b63be1cd7360601839d35468f754fba12558e4f46135bcc6230.png',
    imageEN: 'https://srv-cdn.onedio.com/store/ef3b342eccdd651cfbfb0e3b0a01bb2d2a04cd1c1da161aab2f71f5aa4fdd328.png',
    active: false
  },
  {
    id: 5,
    title: 'Günlük & Aylık Aktif Kullanıcı',
    titleEN: 'Daily & Monthly Active Users',
    description: 'Google Trends’in verilerine gre kelime bazlı aramalardaki Trkiye geneli arama sonuçlarında Mynet, en yakın rakibini yanına yaklaştırmayacak şekilde 1 numara!',
    descriptionEN: 'According to Google Trends data, Mynet is ranked number 1 in Turkey’s nationwide search results for keyword-based searches, leaving its closest competitor far behind!',
    image: 'https://srv-cdn.onedio.com/store/46e9949bee4244c99e18ce22162639ad7f7668351715205c83239abf21364d47.png',
    imageEN: 'https://srv-cdn.onedio.com/store/46e9949bee4244c99e18ce22162639ad7f7668351715205c83239abf21364d47.png',
    active: false
  }
]